import { abeCashupAllCombinedRead, abeCashupOwnCombinedRead } from 'actions/cashup/beCashup.action';
import beGetCashup from 'actions/cashup/beGetCashup.action';
import beGetReconcile from 'actions/cashup/beGetReconcile.action';
import beListReconcile from 'actions/cashup/beListReconcile.action';
import beSaveCashupReconcile from 'actions/cashup/beSaveCashupReconcile.action';
import beInitReaderPayment from 'actions/pos/beInitReaderPayment.action';
import { aTypeCreateUpdateTimeoff, aTypeFetchEventsBySalon, aTypeFetchProceduresBySalon } from 'actions/shared.types';
import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

// These are the most simple getters,
// they will navigate the path, return the data found
// or default to null for null/undefined

export const selectRequestStatus = ($) => $?.requestStatus ?? null;

const on = (prefix) => nullBind(getAnyOrNull, ['requestStatus', prefix]);

export const selectRsInitVoidTransaction = on('INIT_VOID_TRANSACTION');
export const selectRsVoidTransactionDetails = on('VOID_TRANSACTION_DETAILS');

export const selectRsCheckoutFetchAllDeposits = on('CHECKOUT_FETCH_ALL_DEPOSITS');
export const selectRsCheckoutFetchOneDeposit = on('CHECKOUT_FETCH_DEPOSIT');
export const selectRsCheckoutInitDeposit = on('CHECKOUT_INIT_DEPOSIT');

export const selectRsDepositClientsList = on('GET_DEPOSIT_CLIENTS_LIST');
export const selectRsFetchDepositClientList = on('DEPOSIT_CLIENT_LIST');

export const selectRsSchedulerFetchDeposit = on('SCHEDULER_FETCH_DEPOSIT');

export const selectRsFetchEventsBySalon = on(aTypeFetchEventsBySalon.name);
export const selectRsFetchProceduresBySalon = on(aTypeFetchProceduresBySalon.name);
export const selectRsCreateUpdateTimeoff = on(aTypeCreateUpdateTimeoff.name);

export const selectRsBeGetCashup = on(beGetCashup.ATAG);
export const selectRsAbeCashupAllCombinedRead = on(abeCashupAllCombinedRead.ATAG);
export const selectRsAbeCashupOwnCombinedRead = on(abeCashupOwnCombinedRead.ATAG);
export const selectRsBeGetReconcile = on(beGetReconcile.ATAG);
export const selectRsBeListReconcile = on(beListReconcile.ATAG);
export const selectRsBeSaveCashupReconcile = on(beSaveCashupReconcile.ATAG);

export const selectRsBeInitReaderPayment = on(beInitReaderPayment.ATAG);
